// extracted by mini-css-extract-plugin
export default {"minesRiskAutoWrap":"styles_minesRiskAutoWrap__fwWiV","minesRiskDropWrap":"styles_minesRiskDropWrap__sdx2I","minesCheckboxAutoWrap":"styles_minesCheckboxAutoWrap__EgIsR"};